import { handle420 } from 'apis/HandleError';
import { apiConfig, appConfig } from 'config';

const STATUS_CHECK_INTERVAL_MS = 2000;

const checkResponse = (url, data, resolve, reject) => {
  const auth = window.__APP_AUTH;
  const headers = {
    Accept: '*/*',
    'cache-control': 'no-cache',
    Authorization: 'Bearer ' + auth?.accessToken,
    'accept-encoding': 'gzip, deflate'
  };

  if (data == null) {
    fetch(url, { headers: headers, method: 'GET' })
      .then((result) => {
        result.json().then((jsonData) => checkResponse(url, jsonData, resolve, reject));
      })
      .catch((error) => console.log(error));
    return;
  }
  console.log(data.runtimeStatus);
  if (data.runtimeStatus !== 'Pending' && data.runtimeStatus !== 'Running') {
    //TODO perform an action
    //console.log("DONE! Data:", data);
    resolve(data);
    return;
  }

  setTimeout(function () {
    fetch(url, { headers: headers, method: 'GET' }).then((result) => {
      result.json().then((jsonData) => {
        checkResponse(url, jsonData, resolve, reject);
      });
    });
  }, STATUS_CHECK_INTERVAL_MS);
};

export function setGain(id, targetVUL_Gain, targetHUL_Gain, targetVDL_Gain, targetHDL_Gain, retry = false) {
  if (!targetVUL_Gain && !targetHUL_Gain && !targetVDL_Gain && !targetHDL_Gain) return;
  const auth = window.__APP_AUTH;
  let headers = {
    Accept: '*application/json*',
    'cache-control': 'no-cache',
    Origin: `${appConfig.webBaseUrl}/`,
    Authorization: 'Bearer ' + auth?.accessToken,
    'Content-Type': 'application/json',
    mode: 'cors'
  };

  let postBody = {
    ...(targetVUL_Gain && { VUL_Gain: targetVUL_Gain }),
    ...(targetHUL_Gain && { HUL_Gain: targetHUL_Gain }),
    ...(targetVDL_Gain && { VDL_Gain: targetVDL_Gain }),
    ...(targetHDL_Gain && { HDL_Gain: targetHDL_Gain })
  };

  return new Promise((resolve, reject) => {
    let url = apiConfig.cmServiceSetGain(id);
    fetch(url, { method: 'POST', headers: headers, body: JSON.stringify(postBody) })
      .then((response) => {
        if (response.status === 200) {
          response.json().then((data) => {
            console.log('Set Gain response:', data);
            let url = data.statusQueryGetUri;
            checkResponse(url, null, resolve, reject);
          });
        } else {
          throw new Error(response.status);
        }
      })
      .catch((e) => {
        console.log('Set Gain error = ' + e.message);
        switch (e.message) {
          case '420':
            const auth = window.__APP_AUTH;
            if (auth && retry) {
              return auth.renewSession().then(() => {
                return setGain(id, targetVUL_Gain, targetHUL_Gain, targetVDL_Gain, targetHDL_Gain, (retry = false));
              });
            } else {
              handle420();
            }
            break;
          case '403':
            reject(e);
            break;
          default:
            reject(e);
        }
        return;
      });
  });
}
